import axios from "axios";
import { DesEncriptar } from "./Util/Encripcion";

// Este código es para validar que entorno es

// Determinar ruta  según entorno
let apiPath = process.env.REACT_APP_API_URL;
//console.log("apiPath: ", apiPath);
if (process.env.REACT_APP_ENV === "dev") {
  apiPath = process.env.REACT_APP_API_PATH_DEV;
}

const baseURL = `${process.env.REACT_APP_API_URL}${apiPath}`;

//console.log("baseURL:", baseURL);
const instance = axios.create({
  baseURL: baseURL, // URL base de tu API
});

// Interceptor de petición: modifica la URL antes de enviarla
instance.interceptors.request.use(
  (config) => {
    //console.log("config:", config);
    if (process.env.REACT_APP_ENV === "dev") {
      const prodPath = process.env.REACT_APP_API_PATH_PROD;
      apiPath = process.env.REACT_APP_API_PATH_DEV;
      config.url = config.url.replace(prodPath, apiPath);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const requestURL = response.config.url;

      //if (requestURL.includes("login")) {
      //////console.log("PATH ES LOGIN");
      //} else {
      //////console.log("response.data.datos:", response.data.datos);
      var desencriptado = DesEncriptar(response.data.datos);
      //console.log("Datos desencriptados:"+requestURL+"  ", desencriptado);
      //response.data.datos=desencriptado;
      response.data = JSON.parse(desencriptado);
      //}
    }
    return response;
  },
  (error) => {
    // Si hay un error en la respuesta, también puedes manejarlo aquí
    return Promise.reject(error);
  }
);

export default instance;
